import React from 'react';
import { node } from 'prop-types';
import variables from '../../styles/variables.module.scss';

const Highlight = ({ children }) => (
  <span style={{ color: variables.springGreen }}>{children}</span>
);

Highlight.propTypes = {
  children: node.isRequired,
};

export default Highlight;
